<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#FFFFFF'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="home" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <p>
        <span>{{ this.$store.getters.TRANSLATIONS["to_get_your_car"] }}</span>
        {{ this.$store.getters.TRANSLATIONS["head_to_valet"] }}
        <br />
        {{ this.$store.getters.PICKUP_LOCATION }}
      </p>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="home()" class="button">
        {{ this.$store.getters.TRANSLATIONS["back_home"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      home: () => {
        this.$router.push("/hello");
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.content {
  flex: 1 0 auto;
  display: flex;
  font-size: 6vw;
  color: #ffffff;
}
.content p {
  margin: auto;
  text-align: center;
  padding: 0 3vw;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/FreeParking.vue